import {
  ISignificanceQueryFieldsFragment,
  SignificanceModeKey,
} from '../../apollo/graphqlSchema';
import { ISignificanceBuilderFields } from '../../../redux/slices/oldBuilder/significance/types';
import { UnreachableCaseError } from 'ts-essentials';

const parseCriteriaFields = (
  criteria: ISignificanceQueryFieldsFragment['criteria'],
): ISignificanceBuilderFields['criteria'] => {
  switch (criteria.__typename) {
    case 'BreakdownCriteria': {
      const { field, controlGroup, variants } = criteria;
      return {
        modeKey: SignificanceModeKey.Breakdown,
        field,
        controlGroup,
        variants,
      };
    }
    case 'SegmentCriteria': {
      const { segmentControlGroup, segmentVariants } = criteria;
      return {
        modeKey: SignificanceModeKey.Segment,
        controlGroup: segmentControlGroup,
        variants: segmentVariants,
      };
    }
    case 'ExperimentCriteria': {
      const { experiment, criteriaControlGroup, criteriaVariants } = criteria;
      return {
        modeKey: SignificanceModeKey.Experiment,
        experimentId: experiment,
        controlGroup: criteriaControlGroup,
        variants: criteriaVariants,
      };
    }
    default: {
      throw new UnreachableCaseError(criteria);
    }
  }
};

export default parseCriteriaFields;
